import { AxiosResponse } from 'axios'
import api from './Api'

export const updateCheckIn = (checkIn: ICheckIn) => {
    return api.put(`${process.env.REACT_APP_API_DOMAIN}/check-in`, checkIn)
}
export const createCheckInByWalkIn = (checkInCreateByWalkInRequest: ICheckInCreateByWalkInRequest) => {
    return api.post(`${process.env.REACT_APP_API_DOMAIN}/check-in/walk-in/v2`, checkInCreateByWalkInRequest)
}
export const getReservationListForCheckInHistory = (search: string, startDateTime: string, endDateTime: string): Promise<AxiosResponse<ICheckInHistoryGetAdminResponse[]>> => {
    return api.get(`${process.env.REACT_APP_API_DOMAIN}/reservation/check-in/history?search=${search}&startDateTime=${encodeURIComponent(startDateTime)}&endDateTime=${encodeURIComponent(endDateTime)}`)
}